if (!customElements.get('sk-cart-core')) {

  const CART_SECTIONS = [
    { id: 'Cart', section: 'view-basket', selector: '.basket-form' },
    { id: 'cart-drawer-toggle', section: 'basket-pip', selector: '.count-badge' },
  ];

  const QUANTITY_DEBOUNCE_MS = 300;

  class SiCart extends HTMLElement {
    connectedCallback() {
      this.busy = false;

      this.onQuantityInput = debounce((event) => this.handleChange(event), QUANTITY_DEBOUNCE_MS);
      this.onRemove = (event) => this.setQuantity(event.detail.index, 0);
      this.onRefresh = () => this.reload();

      this.addEventListener('change', this.onQuantityInput);
      document.addEventListener('cart:remove', this.onRemove);
      document.addEventListener('cart:refresh', this.onRefresh);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onQuantityInput);
      document.removeEventListener('cart:remove', this.onRemove);
      document.removeEventListener('cart:refresh', this.onRefresh);
    }

    handleChange(event) {
      const field = event.target;
      if (field.type === 'number') {
        this.setQuantity(field.dataset.index, field.value);
      } else if (field.id === 'CartSpecialInstructions') {
        this.saveNote(field.value);
      }
    }

    postJSON(url, payload) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      }).then((response) => response.json());
    }

    saveNote(note) {
      return this.postJSON(`${theme.routes.cart_update_url}.js`, { note });
    }

    setQuantity(line, quantity) {
      if (this.busy) return;
      this.lock(line);

      dispatchCustomEvent('line-item:change:start', { quantity });

      return this.postJSON(theme.routes.cart_change_url, {
        line,
        quantity,
        sections: CART_SECTIONS.map((s) => s.section),
        sections_url: window.location.pathname,
      })
        .then((cart) => {
          if (cart.errors) {
            this.showError(line, cart.errors);
            return;
          }
          this.render(cart.sections);
          dispatchCustomEvent('line-item:change:end', { quantity, cart });
        })
        .catch(() => {

          this.unlock(line);
          return this.reload();
        })
        .finally(() => this.unlock(line));
    }

    reload() {
      if (this.busy) return;
      this.lock();

      const sections = CART_SECTIONS.map((s) => s.section).join(',');

      return fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => response.json())
        .then((sections) => this.render(sections))
        .catch(() => {})
        .finally(() => this.unlock());
    }

    render(sections) {
      if (!sections) return;

      CART_SECTIONS.forEach(({ id, section, selector }) => {
        const host = document.getElementById(id);
        const markup = sections[section];
        if (!host || !markup) return;

        const target = host.querySelector(selector) || host;
        const incoming = new DOMParser().parseFromString(markup, 'text/html').querySelector(selector);
        if (incoming) target.innerHTML = incoming.innerHTML;
      });
    }

    showError(line, message) {
      const slot =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      if (!slot) return;

      slot.removeAttribute('hidden');
      const text = slot.querySelector('.cart-item__error-text');
      if (text) text.innerHTML = message;
    }

    lock(line) {
      this.busy = true;
      this.classList.add('basket-disabled');
      this.row(line)?.classList.add('loading');
    }

    unlock(line) {
      this.busy = false;
      this.classList.remove('basket-disabled');
      this.row(line)?.classList.remove('loading');
    }

    row(line) {
      return line ? this.querySelector(`#CartItem-${line}`) : null;
    }
  }

  customElements.define('sk-cart-core', SiCart);
}
